import { fromBeijing } from "./beijing";

export type Preset = "15m" | "1h" | "12h" | "24h" | "7d" | "30d" | "90d";
/** 自定义范围的 from、to 是北京时间文本（D174），格式 YYYY-MM-DD HH:mm:ss。 */
export type DateRangeValue = { preset: Preset } | { from: string; to: string };

export const PRESETS: Array<[Preset, string, number]> = [["15m", "近 15 分钟", 15], ["1h", "近 1 小时", 60], ["12h", "近 12 小时", 720], ["24h", "近 24 小时", 1440], ["7d", "近 7 天", 10080], ["30d", "近 30 天", 43200], ["90d", "近 90 天", 129600]];

/** 把北京时间文本 YYYY-MM-DD HH:mm:ss 解析成时刻，也兼容不带秒的旧格式。 */
export function parseBeijing(s: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})(?::(\d{2}))?$/.exec(s ?? "");
  return m ? fromBeijing(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] ?? 0)) : null;
}

/** 把值换算成绝对起止时间，供查询参数使用。 */
export function resolveRange(v: DateRangeValue, now = new Date()): { from: Date; to: Date } | null {
  if ("preset" in v) {
    const minutes = PRESETS.find((p) => p[0] === v.preset)?.[2] ?? 60;
    return { from: new Date(now.getTime() - minutes * 60_000), to: now };
  }
  const from = parseBeijing(v.from), to = parseBeijing(v.to);
  return from && to ? { from, to } : null;
}
